import { InsuredUser } from 'app/components/insured-users';
import { BenefitsList } from 'app/components/paywall/paywall';
import { images } from 'app/design/images';
import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { PCImage } from 'app/design/primitives/image';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';
import { useNavigation } from 'app/hooks/navigation';
import { askForPayment } from 'app/network/plan';
import { PlanRecurrenceEnum } from 'app/schemas/plan';
import { isNotWhiteLabel } from 'app/utils/helpers';
import { Trans } from 'react-i18next';
import { theme } from './shared';
import type { ActivePlan } from './shared';

export const PlanBenefits = ({
  activePlan,
  isB2CWithRecurrence,
  isDragonEventActive,
}: {
  activePlan: ActivePlan | undefined;
  isB2CWithRecurrence: boolean;
  isDragonEventActive: boolean;
}) => {
  const navigation = useNavigation();
  const { t } = useScopedTranslation();
  const showDragonPromotion = Boolean(activePlan && askForPayment(activePlan) && isDragonEventActive);

  return (
    <>
      <Column marginVertical="spacing.general.x2">
        <BenefitsList
          header={
            <Column gap="spacing.general.x4" marginBottom="spacing.general.x3">
              <Text fontWeight="700" variant="bodyBase">
                {t('planExpired.advantages')}
              </Text>
              <InsuredUser otherUser={{ insured: isNotWhiteLabel() }} placement="my-plan" />
            </Column>
          }
          showCancelAnytime={isB2CWithRecurrence ? activePlan?.recurrence === PlanRecurrenceEnum.monthly : false}
        />
      </Column>

      {showDragonPromotion ? (
        <Column
          style={{
            borderRadius: theme.borderRadii['radius.lg'],
            backgroundColor: theme.colors['surface.tertiary'],
            width: '100%',
          }}
        >
          <PCImage
            aspectRatio={343 / 160}
            source={images.dragon2024}
            style={{
              borderTopRightRadius: theme.borderRadii['radius.lg'],
              borderTopLeftRadius: theme.borderRadii['radius.lg'],
            }}
          />
          <Column gap="spacing.general.x4" margin="spacing.general.x4">
            <Column gap="spacing.general.x2">
              <Text fontSize={18} lineHeight={24} variant="bodyBase">
                <Trans components={{ strong: <Text fontWeight="600" /> }} i18nKey="promoDragonText" ns="my-plan" />
              </Text>
              <Text fontSize={16} lineHeight={20} variant="bodyBase">
                <Trans components={{ strong: <Text fontWeight="600" /> }} i18nKey="promoDragonText2" ns="my-plan" />
              </Text>
            </Column>
            <Button onPress={() => navigation.navigate('payment', undefined, { pop: true })} variant="secondary">
              {t('promoDragonButtonText')}
            </Button>
          </Column>
        </Column>
      ) : null}
    </>
  );
};
